import * as DomLegacy from 'react-dom';
import * as TDomNext from 'react-dom/client';

let DomNext: typeof TDomNext | undefined = undefined;

try {
    DomNext = require('react-dom/client');
} catch (err) {
    // Swallow error in legacy React environment
}

type TCreateRoot = typeof TDomNext['createRoot'];
type TRenderNext = ReturnType<TCreateRoot>['render'];
type TRenderLegacy = typeof DomLegacy['render'];
type TReactElementNext = Parameters<TRenderNext>[0];
type TReactElementLegacy = Parameters<TRenderLegacy>[0];

/**
 * A shim over several React DOM APIs, ensuring compatibility with versions 16-18
 * via duck typing.
 */

const renderReact = (
    reactElement: TReactElementNext | TReactElementLegacy,
    rootElement: Element | DocumentFragment
): void => {
    const createRoot: TCreateRoot | undefined = DomNext?.createRoot;
    const render: TRenderLegacy | undefined = DomLegacy?.render;

    if (typeof createRoot === 'function') {
        // New React DOM API available

        const root = createRoot(rootElement);

        root.render(reactElement);
    } else if (typeof render === 'function') {
        // Falling back to legacy React DOM API

        render(reactElement as TReactElementLegacy, rootElement);
    } else {
        throw new Error('Could not find any compatible React DOM API in the environment.');
    }
};

export default renderReact;
